import React from "react";


export default function LoginCallback() {
    return (<div/>)
}